module.exports = __webpack_public_path__ + "static/media/CircleActive.5c7e3423.png";